import React, { useState } from "react";
import { api } from "../lib/api";
import { PageHero, Field, SuccessCard } from "../components/FormKit";
import { toast } from "sonner";

export const Contact = () => {
  const [f, setF] = useState({ name: "", email: "", phone: "", subject: "", message: "" });
  const [done, setDone] = useState(false);
  const set = (k, v) => setF({ ...f, [k]: v });
  const submit = async (e) => { e.preventDefault(); try { await api.post("/leads/contact", f); setDone(true); toast.success("Message sent"); } catch { toast.error("Please try again."); } };

  return (
    <div data-testid="contact-page">
      <PageHero eyebrow="We're here to help" title="Contact TAVEN" subtitle="Questions about shopping, selling, affiliates, or the Sebara Card? Reach out and our team will respond." />
      <section className="py-14 px-4 md:px-8 lg:px-12 mx-auto max-w-2xl">
        {done ? <SuccessCard title="Message received." text="Thank you for contacting TAVEN SYSTEM LLC. We'll be in touch soon." /> : (
          <form onSubmit={submit} className="grid gap-4" data-testid="contact-form">
            <Field label="Name" name="name" value={f.name} onChange={set} required />
            <Field label="Email" name="email" type="email" value={f.email} onChange={set} required />
            <Field label="Phone (optional)" name="phone" value={f.phone} onChange={set} />
            <Field label="Subject" name="subject" value={f.subject} onChange={set} />
            <Field label="Message" name="message" value={f.message} onChange={set} textarea required />
            <button className="bg-taven-black text-white font-bold uppercase tracking-wider py-4 hover:bg-taven-orange transition-colors" data-testid="contact-submit">Send Message</button>
          </form>
        )}
      </section>
    </div>
  );
};

export default Contact;
